// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtistLayout_container__J0hoW"};